import React from 'react';
import { Box, Typography } from '@mui/material';
import GroupIcon from "@mui/icons-material/Group";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import MoveToInboxIcon from "@mui/icons-material/MoveToInbox";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import PauseCircleIcon from "@mui/icons-material/PauseCircle";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";

interface LeadStats {
  totalLeadsCount: number;
  gettingReadyLeads: number;
  inProgressLeadsCount: number;
  finishedLeadsCount: number;
  failedLeadsCount: number;
  blackListedCount: number;
  pausedCount: number;
  waitingUntilCount: number;
}

interface StatusCardsProps {
  leadStats: LeadStats | null;
}

const StatusCards: React.FC<StatusCardsProps> = ({ leadStats }) => {
  const statusIconMap: Record<string, JSX.Element> = {
    "All Leads": <GroupIcon sx={{ color: "#325CD6" }} />,
    "In progress": <AccessTimeIcon sx={{ color: "#325CD6" }} />,
    "Completed": <MoveToInboxIcon sx={{ color: "#325CD6" }} />,
    "Awaiting": <HourglassEmptyIcon sx={{ color: "#325CD6" }} />,
    "Paused": <PauseCircleIcon sx={{ color: "#325CD6" }} />,
    "Blacklisted": <ReportProblemIcon sx={{ color: "#325CD6" }} />,
  };

  const leadStatusMap = [
    { label: "All Leads", key: "totalLeadsCount" },
    { label: "In progress", key: "inProgressLeadsCount" },
    { label: "Completed", key: "finishedLeadsCount" },
    { label: "Awaiting", key: "waitingUntilCount" },
    { label: "Paused", key: "pausedCount" },
    { label: "Blacklisted", key: "blackListedCount" },
  ];

  return (
    <Box sx={{ display: "flex", gap: 4, px: 2, py: 3 }}>
      {leadStatusMap.map(({ label, key }, index) => (
        <Box
          key={index}
          sx={{
            width: "15%",
            minWidth: 140,
            textAlign: "left",
            border: "1px solid #E5EAF2",
            borderRadius: "12px",
            py: 2,
            px: 2,
            display: "flex",
            flexDirection: "column",
            alignItems: "left",
            justifyContent: "left",
            cursor: "pointer",
          }}
        >
          <Box
            sx={{
              bgcolor: "#325CD61A",
              width: 40,
              height: 40,
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mb: 1.5,
            }}
          >
            {statusIconMap[label]}
          </Box>
          <Typography
            variant="body2"
            fontWeight={500}
            color="#1A1A1A"
          >
            {label}
          </Typography>
          <Typography
            variant="h6"
            fontWeight={700}
            color="#1A1A1A"
            mt={0.5}
          >
            {leadStats
              ? leadStats[key as keyof typeof leadStats] ?? 0
              : 0}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default StatusCards; 